import { detachNode } from 'utils/dom';

export default function () {
	return detachNode( this.node );
}
